import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios"
import { Box, Button, CircularProgress, IconButton } from "@mui/material"
import { AXIOS_API_INSTANCE, RENTAL_CONTRACT_COLOR_MAP, RENTAL_STATUS_FRIENDLY_NAMES } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import dayjs from "dayjs"
import Scheduler from "@aldabil/react-scheduler";
import { useTheme } from "@emotion/react"

export default function RentalItemCalendarModal({
    item,
    open,
    closeModal,
}) {
    const theme = useTheme()
    const [isLoading, setIsLoading] = React.useState(false)
    const [contracts, setContracts] = React.useState([])
    const [selectedDate, setSelectedDate] = React.useState(new Date())

    const getContracts = () => {
        const filterVar = { 'rental_item_id.eq': item.id }
        setIsLoading(true)
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalcontractitems", {
                        params: {
                            filters: JSON.stringify(filterVar),
                        },
                    }),
                ])
                .then(
                    axios.spread((contracts) => {
                        console.log(contracts)
                        let events = []
                        contracts.data.data.forEach(contract => {
                            const start = contract.start_date ? dayjs.utc(contract.start_date).local() : dayjs.utc(contract.estimated_start_date).local()
                            const end = contract.end_date ? dayjs.utc(contract.end_date).local() : dayjs.utc(contract.estimated_end_date).local()
                            events.push(
                                {
                                    event_id: contract.rental_contract_id,
                                    title: `${contract.rental_contract_id} - ${RENTAL_STATUS_FRIENDLY_NAMES[contract.status]}${contract.rental_item.bulk_type ? ` (x${contract.quantity})` : ''}`,
                                    start: start.toDate(),
                                    end: (end < start ? start.add(1, 'h') : end).toDate(),
                                    color: theme.palette[RENTAL_CONTRACT_COLOR_MAP[contract.status] || 'primary'].main,
                                    editable: false,
                                    deletable: false,
                                    draggable: false
                                })
                        })

                        setContracts(events)
                        setIsLoading(false)
                    })
                )
        )
    }


    const updateSelectedDate = (date) => {
        setSelectedDate(date)
    }

    React.useEffect(() => {
        if (open === true) {
            getContracts()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, selectedDate])

    return (
        <div>
            <Dialog
                open={open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth={'lg'}
            >
                <DialogTitle>
                    {item.unique_name}
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {isLoading &&
                        < Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress />
                        </Box>
                    }
                    {!isLoading &&
                        <Scheduler
                            // selectedDate={selectedDate}
                            view={"month"}
                            events={contracts}
                            onSelectedDateChange={updateSelectedDate} // TODO: Update package version once it is fixed to add support for this
                            // onConfirm={handleConfirm}
                            viewerExtraComponent={(fields, event) => <Button href={`/Contracts/${event.event_id}`}>View Contract</Button>}
                        />
                    }
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        </div >
    )
}
